export default {
  dependencies: {
  },
  resolvers: {
  },
};
